export type Facility = {
	id: string;
	slug: string;
	name: string;
	address: string;
	zipCity: string;
	phone: string;
	email: string;
	openingHours: { label: string; hours: string }[];
	coordinates: { latitude: number; longitude: number };
	status: "active" | "coming-soon";
};

export const facilities: Facility[] = [
	{
		id: "norrkoping",
		slug: "norrkoping",
		name: "Norrköping",
		address: "Moa Martinsons Gata 2",
		zipCity: "603 78 Norrköping",
		phone: "+46 11-60 501",
		email: "info@vdmotor.se",
		openingHours: [
			{ label: "Mån–fre", hours: "10–18" },
			{ label: "Lör", hours: "11–14" },
			{ label: "Sön", hours: "Stängt" },
		],
		coordinates: { latitude: 58.581429, longitude: 16.136018 },
		status: "active",
	},
	{
		id: "jonkoping",
		slug: "jonkoping",
		name: "Jönköping",
		address: "Österängsvägen 3",
		zipCity: "554 63 Jönköping",
		phone: "+46 11-60 501",
		email: "jonkoping@vdmotor.se",
		openingHours: [
			{ label: "Mån–fre", hours: "10–18" },
			{ label: "Lör", hours: "11–14" },
			{ label: "Sön", hours: "Stängt" },
		],
		coordinates: { latitude: 57.783831713263766, longitude: 14.234704615717536 },
		status: "active",
	},
];

/** Get a facility by its URL slug */
export const getFacilityBySlug = (slug: string) => facilities.find((f) => f.slug === slug);
